// Remove 'required' attribute from fields in hidden blocks when the page loads
export const loadHiddenBlocks = () => {
  $(window).on('load', function () {
    const $hiddenBlocks = $('[data-type="hidden"]');

    $hiddenBlocks.each(function () {
      if (!$(this).is(':visible')) {
        $(this).find('input').attr('required', false);
      }
    });
  });
};

// Handle dependent fields visibility on change
export const handleDependentFields = () => {
  $(document).on('change', '.js-select-change', function () {
    let $block = $('.block_' + $(this).val());

    $(this).nextAll('[data-type="hidden"]').hide().find('input').val('').attr('required', false);

    if ($block.length) {
      if (!$block.is(':visible')) {
        $block.show().find('input').val('').attr('required', true);
      }
    }
  });
};
